const bookPropertyButton = document.querySelector('.book__property-form');
const closeBookPropertyButton = document.querySelector('.close__button');
const bookProperty = document.querySelector('.book__property');
const propertyForm = document.querySelector('.form__default--property');
const bodyOverlay = document.querySelector('.body__overlay');

if(bookPropertyButton){
    bookPropertyButton.addEventListener('click', function handleClick(event) {
        propertyForm.classList.add('active');
        bodyOverlay.classList.add('active');
    });
}

if(closeBookPropertyButton){
    closeBookPropertyButton.addEventListener('click', function handleClick(event) {
        propertyForm.classList.remove('active');
        bodyOverlay.classList.remove('active');
    });
}

if(bodyOverlay){
    bodyOverlay.addEventListener('click', function handleClick(event) {
        bodyOverlay.classList.remove('active');
        propertyForm.classList.remove('active');
    });
}

document.addEventListener("keydown", function(e) {
    e = e || window.event;
    e.keyCode;
    if (e.keyCode == 27) {
        propertyForm.classList.remove('active');
        bodyOverlay.classList.remove('active');
    }
});
